module.exports = __webpack_public_path__ + "static/img/img-1.82a7073.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew_/detail/jolin/1/img-1.jpg
// module id = Lv+3
// module chunks = 1